import type { TActionItemUrgency } from '@model/actionItem';

export const URGENCY_TOOLTIPS: Record<TActionItemUrgency, string> = {
  Standard:
    'There is an opportunity to extend equipment life with adjustments in lubrication, cleaning, routine maintenance, or operational practices.',
  High: 'A moderate phase of wear has been reached. It is recommended to begin preparing for repairs by ordering parts and scheduling labor and downtime.',
  Critical: 'A machine failure could be imminent. Please investigate as soon as possible.',
};
